<template>
    <div id="live">
        <button v-if="settings.enableBible" type="button" @click="toggleFullScreen" class="fullscreen"></button>
        <fullscreen ref="fullscreen" @change="fullscreenChange">
            <button v-if="settings.toggleFullscreen && settings.enableBible" @click="toggleFullScreen" class="fullscreen"></button>
            <div id="sermons-live" :class="['valign-wrapper', settings.theme, settings.toggleBible ? 'bibleVisible' : '']">
                <div class="slides-lyrics">
                    <div v-if="liveContent.content.type !== 'verse'" class="booya-left"></div>
                    <template v-if="liveContent.type === 'song'">
                        <template v-if="liveContent.content.type === 'intro'">
                            <div style="padding: 35px 0;">
                                <div class="title" :style="[settings.textAlign === '' ? {'text-align': 'left'} : {'text-align': settings.textAlign}, {'font-size': settings.fontSizes.main}]">{{liveContent.content.details.title}}</div>
                                <div class="date" :style="[settings.textAlign === '' ? {'text-align': 'left'} : {'text-align': settings.textAlign}, {'font-size': settings.fontSizes.date}]">{{liveContent.content.details.date}}</div>
                                <div v-if="liveContent.content.details.message" class="message" :style="[settings.textAlign === '' ? {'text-align': 'left'} : {'text-align': settings.textAlign}, {'font-size': settings.fontSizes.message}]">{{liveContent.content.details.message}}</div>
                            </div>
                        </template>
                        <template v-else-if="liveContent.content.type === 'title'">
                            <div style="padding: 35px 0;">
                                <div class="songTitle" :style="[settings.textAlign === '' ? {'text-align': 'left'} : {'text-align': settings.textAlign}, {'font-size': settings.fontSizes.songTitle}]" v-html="liveContent.content.details"></div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="lyrics" :style="[settings.textAlign === '' ? {'text-align': 'left'} : {'text-align': settings.textAlign}, {'font-size': settings.fontSizes.lyrics}]" v-html="liveContent.content.details"></div>
                        </template>
                    </template>
                    <template v-if="liveContent.type === 'custom'">
                        <template v-if="liveContent.content.type === 'verse'">
                            <div class="reference" :style="{'font-size': settings.fontSizes.reference}" v-html="referenceDisplay(liveContent.content.content)"></div>
                            <div class="verse" :style="{'font-size': settings.fontSizes.verse}" v-html="liveContent.content.content.main"></div>
                        </template>
                        <template v-else-if="liveContent.content.type === 'image'">
                            <img class="image" alt="slide note" :src="liveContent.content.content.main">
                        </template>
                        <template v-else-if="liveContent.content.type === 'video'">
                            <div class="video">
                                <iframe title="noteFrame" :src="liveContent.content.content.main" frameBorder='0' allowfullscreen="allowfullscreen"></iframe>
                            </div>
                        </template>
                        <template v-else-if="liveContent.content.type === 'custom'">
                            <div class="custom" :style="{'font-size': settings.fontSizes.verse}" v-html="liveContent.content.content.main + ('<span>' + liveContent.content.content.main.replace(/<[^>]+>/g, '') + '</span>')"></div>
                        </template>
                        <template v-else-if="liveContent.content.type === 'article'">
                            <div id="article">
                                <div class="article-source" v-if="liveContent.content.content.article.source">
                                    <div class="article-source-line"></div>
                                    {{liveContent.content.content.article.source}}
                                    <div class="article-source-line"></div>
                                </div>
                                <div class="articleContent">
                                    <div class="article-title" v-if="liveContent.content.content.article.title">{{liveContent.content.content.article.title}}</div>
                                    <div class="article-details" v-if="liveContent.content.content.article.author != '' || liveContent.content.content.article.date != ''">
                                        <div class="article-author" v-if="liveContent.content.content.article.author">{{liveContent.content.content.article.author}}</div>
                                        <div class="article-date" v-if="liveContent.content.content.article.date">{{liveContent.content.content.article.date}}</div>
                                    </div>
                                    <div class="article-image-div" v-if="liveContent.content.content.article.imageURL">
                                        <img :src="liveContent.content.content.article.imageURL">
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <div v-if="liveContent.content.type !== 'verse'" class="booya-right"></div>
                </div>
                
                <a v-if="settings.enableBible" class="toggle-bible btn" v-on:click="toggleBible()"><i class="material-icons">expand_less</i></a>
            </div>

            <div id="bible-pane" :class="[settings.toggleBible ? 'bibleVisible' : '']">
                <Bible v-on:bibleContent="updateBible($event)"/>
            </div>
        </fullscreen>
    </div>
</template>
<script>

import io from 'socket.io-client';
import fullscreen from 'vue-fullscreen';
import Vue from "vue";
import Bible from '../../components/Bible';
// import func from 'vue-editor-bridge';

Vue.use(fullscreen);

export default {
    name: "Live",
    data: function() {
        return {   
            socket: io("https://hofcc-ws-service.azurewebsites.net/p"),
            liveContent: {
                type: "custom",
                content: {}
            },
            defaultVersion: "NKJV",
            settings: {
				theme: 'white-screen-theme',
				textAlign: 'center',
				fontSizes: {
					main: '3rem',
					date: '2.25rem',
					message: '2.25rem',
					songTitle: '3rem',
					lyrics: '2.5rem',
					verse: '2.5rem',
					reference: '2.15rem'
                },
                toggleBible: false,
                enableBible: false,
                toggleFullscreen: false
            }
        }
    },
    components: { Bible },
    created: function() {
        let self = this;

        if (typeof this.$route.params.theme !== "undefined" && this.$route.params.theme == "green") {
            this.settings.theme = "green-screen-theme";
        }
        else if (typeof this.$route.params.theme !== "undefined" && this.$route.params.theme == "green2") {
            this.settings.theme = "green-screen-theme-2";
        }
        else if (typeof this.$route.params.theme !== "undefined" && this.$route.params.theme == "green3") {
            this.settings.theme = "green-screen-theme-3";
        }
        else if (typeof this.$route.params.theme !== "undefined" && this.$route.params.theme == "church") {
            this.settings.theme = "hofcc-ani-theme";

            this.settings.fontSizes = {
                main: '8rem',
                date: '4rem',
                message: '4rem',
                songTitle: '6.5rem',
                lyrics: '5.6rem',
                verse: '5rem',
                reference: '3.5rem'
            }
        }
        else {
            this.settings.enableBible = true;
        }

        const presentationIdParam = this.$route.params.presentationid;
        this.socket.emit('joined room', presentationIdParam);

        this.socket.on('connect', function () {
            if (presentationIdParam != "") {
                self.socket.emit('reconnect room', presentationIdParam);
            }
        })
        
        this.socket.on('connected', (content) => {
            console.log("connected", this.socket);
            if (content && content.hasOwnProperty("type")) {
                let contentType = content.type.trim();
                if (contentType == "intro" || contentType == "title" || contentType == "lyrics") {
                    let tempContent = {
                        type: "song",
                        content: content
                    }
                    this.liveContent = tempContent;
                }
                else if (contentType == "custom" || contentType == "verse" || contentType == "image" || contentType == "video") {
                    let tempContent = {
                        type: "custom",
                        content: content.content
                    }
                    this.liveContent.type = "custom";
                    this.liveContent.content = content.content

                    console.log(this.liveContent)
                    if (contentType == "verse") {
                        //tempContent.content.content.sub
                        //https://www.oreilly.com/library/view/javascript-the-definitive/0596101996/re167.html
                        console.log(tempContent);
                    }
                }
                else {
                    this.liveContent = content;
                }
            }
        });

        this.socket.on('content update', (content) => {
            console.log("update", content);
            if (content != "") {
                this.liveContent = content;
            }
            else {
                this.liveContent = { type: "custom", content: {} };
            }
        });

        this.socket.on('disconnect', (reason) => {
            this.socket.emit('joined room', presentationIdParam);
            console.log("reason", reason);

            if (reason == 'io server disconnect' || reason == 'transport close') {
                if (reason == 'io server disconnect') {
                    // this.connectSocketIO('connect');
                }
            }
        });

        this.socket.on('error', (error) => {
            console.log("error", error)
        });

        this.socket.on('reconnecting', (attemptNumber) => {
            console.log("reconnecting", attemptNumber);
            this.socket.emit('joined room', presentationIdParam);
        });

        this.socket.on('reconnect_error', (error) => {
            console.log("reconnect error", error)
        });

        this.socket.on('reconnect', (attemptNumber) => {
            console.log("reconnected", attemptNumber)
            this.socket.emit('joined room', presentationIdParam);
        });

        this.socket.on('reconnected', (pLastSyncedContent) => {
            console.log("reconnected ", pLastSyncedContent);
        })

    },
    methods: {
        referenceDisplay: function (pContent) {
            let version = this.defaultVersion;
            if (pContent.hasOwnProperty("version")) {
                version = pContent.version.abbreviation;
            }

            if (pContent.hasOwnProperty('altsub') && pContent.altsub != '') {
                return pContent.altsub + " (" + version + ")";
            }
            return pContent.sub + " (" + version + ")";
        },
        // updateSelected: function(pSelected) {
        //     this.sermon = pSelected;
        // }
        toggleBible: function() {
            this.settings.toggleBible = !this.settings.toggleBible;
        },
        toggleFullScreen () {
            this.$refs['fullscreen'].toggle() // recommended
            // this.fullscreen = !this.fullscreen // deprecated
        },
        fullscreenChange (fullscreen) {
            this.settings.toggleFullscreen = fullscreen;
        },
        updateBible: function (content) {
            if (this.$route.params.presentationid != "main") {
                this.liveContent = content;
                this.socket.emit('content external', { content: content, room: this.$route.params.presentationid, action: "insertVerse" });
            }
        }
    }
};
</script>

<style scoped>
    #sermons-live {
        width: 100%;
        height: 100vh;
        padding: 0 2.5rem;
        position: relative;
    }

    .valign-wrapper {
        justify-content: center;
    }

    #sermons-live.bibleVisible {
        width: 70%;
        float: left;
        transition: width .5s;
    }

    .fullscreen {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 9999;
        height: 100px;
        width: 100px;
        border: 0;
        /* color: transparent; */
        background: transparent;
    }
    /* .btn:hover {
        color: #ffffff;
    } */
    
    #sermons-live .toggle-bible {
        position: absolute;
        top: 0;
        right: 0;
        background-color: #5b7c8a;
        transition: all 0.5s ease;
        color: #ffffff;
        z-index: 999;
    }

    #sermons-live .toggle-bible i {
        transform: rotate(-90deg);
    }

    #sermons-live.bibleVisible .toggle-bible i {
        transform: rotate(90deg);
    }

    #sermons-live.bibleVisible .toggle-bible {
        right: 0;
    }

    #bible-pane {
        right: -537px;
        height: 100vh;
        background: #f9f9f9;
        border-left: 10px solid #000;
        position: relative;
        width: 30%;
        float: right;
        display: none;
    }

    #bible-pane.bibleVisible {
        right: 0;
        display: block;
    }

    #sermons-live p,
    #sermons-live .custom {
        text-align: left;
        font-family: 'NewhouseDTPro-Light';
        /* font-weight: bold; */
        line-height: 1.25;
        /* letter-spacing: 1px; */
    }

    #sermons-live .message {
        margin-top: 4rem;
    }

    #sermons-live .verse {
        margin-top: 0;
        padding-top: .5rem;
        border-left: 10px solid;
        padding-left: 2rem;
    }

    #sermons-live p {
        margin: 0 !important;
    }

    #sermons-live .reference {
        /* background: rgba(255,255,255,.3); */
        display: inline-flex;
        padding: 0 35px;
        align-items: center;
        justify-content: center;
        line-height: 1;
        height: 70px;
        text-transform: uppercase;
        font-weight: bold;
        /* text-align: right; */
        /* background: rgba(0,0,0,.3); */
        
    }

    #sermons-live .custom  {
        position: relative;
    }

    #sermons-live .custom >>> span {
        display: none;
    }

    #sermons-live .custom >>> h1+span {
        line-height: .8;
        font-family: 'NewhouseDTCond-ExtBold';
        font-size: 9rem;
        opacity: .1;
        position: fixed;
        bottom: -40px;
        left: 0;
        text-align: center;
        display: block;
        z-index: 2;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: scaleY(1.2);
    }

    #sermons-live .custom >>> h1 {
        font-family: 'NewhouseDTCond-ExtBold';
        /* letter-spacing: 10px; */
        /* opacity: .1; */
        line-height: 1;
    }

    #sermons-live .custom >>> h2 {
        font-family: 'NewhouseDTCond-Light' !important;
        /* letter-spacing: 3px; */
        font-size: 3.5rem;
        font-weight: bold;
    }

    #sermons-live .custom >>> h3,
    #sermons-live .custom >>> h4,
    #sermons-live .custom >>> h5 {
        font-family: 'NewhouseDTCond-Light' !important;
        /* letter-spacing: 3px; */
        font-size: 3rem;
        font-weight: bold;
    }

    #sermons-live .image {
        box-shadow: 5px 10px 15px rgba(0, 0, 0, .5);
        max-height: 90vh; 
        width: 100%;
        /* width: 1250px; */
    }

    #sermons-live .title {
        margin-bottom: 0;
    }


    #sermons-live .video {
        box-shadow: 5px 10px 15px rgba(0, 0, 0, .5);
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
        width: 100vh;
        overflow: hidden;
        max-width: 100%;
        margin: 0 auto;
    }

    #sermons-live .video iframe,
    #sermons-live .video object,
    #sermons-live .video embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    #sermons-live .slides-lyrics,
    #sermons-live .slides-custom {
        z-index: 3;
        line-height: 1.25;
        margin-top: 0;
    }

    #sermons-live .slides-lyrics {
        padding: 0 3rem;
    }
    #sermons-live .slides-custom {
        padding: 0 3rem;
    }

    .lyrics {
        padding: 35px 0;
    }

    /*HOFCC ANIMATION THEME*/

    #sermons-live.hofcc-ani-theme .custom >>> h1 {
        font-family: 'NewhouseDTCond-ExtBold';
        /* letter-spacing: 10px; */
        /* opacity: .1; */
        line-height: 1;
        font-size: 8rem;
        margin: 1.68rem 0 1.68rem 0;
    }

    #sermons-live.hofcc-ani-theme .custom >>> h2 {
        font-family: 'NewhouseDTCond-Light' !important;
        /* letter-spacing: 3px; */
        font-size: 5rem;
        font-weight: bold;
    }

    #sermons-live.hofcc-ani-theme .custom >>> h3,
    #sermons-live.hofcc-ani-theme .custom >>> h4,
    #sermons-live.hofcc-ani-theme .custom >>> h5 {
        font-family: 'NewhouseDTCond-Light' !important;
        /* letter-spacing: 3px; */
        font-size: 5rem;
        font-weight: bold;
    }

    #sermons-live.hofcc-ani-theme {
        /* background-image: radial-gradient(#5b7c8a, #090c0d); */
        background: linear-gradient(33deg, #5b7c8a, #090c0d, #3f4243, #4a636e);
        background-size: 800% 800%;
        
        -webkit-animation: AnimationName 240s ease infinite;
        -moz-animation: AnimationName 240s ease infinite;
        animation: AnimationName 240s ease infinite;
    }

    #sermons-live.hofcc-ani-theme .verse {
        border-left-color: #5b7c8a;
    }

    #sermons-live.hofcc-ani-theme .verse >>> p {
        margin: 0 !important;
        padding: 2rem 0 0 0;
    }

    #sermons-live.hofcc-ani-theme .reference {
        background: #5b7c8a;
        color: #ffffff !important;
    }

    #sermons-live.hofcc-ani-theme .reference,
    #sermons-live.hofcc-ani-theme .verse,
    #sermons-live.hofcc-ani-theme .custom,
    #sermons-live.hofcc-ani-theme .lyrics,
    #sermons-live.hofcc-ani-theme .songTitle,
    #sermons-live.hofcc-ani-theme .message,
    #sermons-live.hofcc-ani-theme .date,
    #sermons-live.hofcc-ani-theme .title {
        color: #ffffff;
        text-shadow: 10px 10px 15px #090c0d;
    }

    .animated {
        animation-duration: 2s;
    }

    @-webkit-keyframes AnimationName {
        0%{background-position:0% 72%}
        50%{background-position:100% 29%}
        100%{background-position:0% 72%}
    }
    @-moz-keyframes AnimationName {
        0%{background-position:0% 72%}
        50%{background-position:100% 29%}
        100%{background-position:0% 72%}
    }
    @keyframes AnimationName { 
        0%{background-position:0% 72%}
        50%{background-position:100% 29%}
        100%{background-position:0% 72%}
    }

    /*GREEN SCREEN THEME*/
    #sermons-live.green-screen-theme {
        background-color: transparent;
        padding-bottom: 8px;
    }

    #sermons-live.green-screen-theme .verse {
        border-left-color: transparent;
        border: none;
        padding-left: 0;
    }

    #sermons-live.green-screen-theme .reference {
        background: #5b7c8a;
        color: #ffffff !important;
        /* width: 500px;
        text-align: center;
        display: block; */
    }

    #sermons-live.green-screen-theme .reference,
    #sermons-live.green-screen-theme .verse,
    #sermons-live.green-screen-theme .custom,
    #sermons-live.green-screen-theme .lyrics,
    #sermons-live.green-screen-theme .songTitle,
    #sermons-live.green-screen-theme .message,
    #sermons-live.green-screen-theme .date,
    #sermons-live.green-screen-theme .title {
        color: #ffffff;
        /* text-shadow: 10px 10px 15px #090c0d; */
    }

    /*GREEN SCREEN 2 THEME*/
    #sermons-live.green-screen-theme-2 {
        background-color: #00b140;
        padding-bottom: 8px;
    }

    #sermons-live.green-screen-theme-2 .slides-lyrics {
        z-index: 3;
        line-height: 1.25;
        padding: 15px 50px 10px 50px; 
        background: #222222;
        box-shadow: 5px 5px 10px;
        position: relative;
        min-width:1125px; 
        border-radius: 5px;
        border: 2px solid #5b7c8a;
        max-width: 1350px;
    }

    .valign-wrapper.green-screen-theme-2 {
        justify-content: flex-end;
        flex-direction: column;
    }

    #sermons-live.green-screen-theme-2 .verse {
        border-left-color: transparent;
        border: none;
        padding-left: 0;
    }

    #sermons-live.green-screen-theme-2 .reference {
        background: #5b7c8a;
        color: #ffffff !important;
        /* width: 500px;
        text-align: center;
        display: block; */
        text-shadow: none;
        top: -35px;
        position: absolute;
        border-radius: 5px;
        text-shadow: none;   
    }

    #sermons-live.green-screen-theme-2 .reference,
    #sermons-live.green-screen-theme-2 .verse,
    #sermons-live.green-screen-theme-2 .custom,
    #sermons-live.green-screen-theme-2 .lyrics,
    #sermons-live.green-screen-theme-2 .songTitle,
    #sermons-live.green-screen-theme-2 .message,
    #sermons-live.green-screen-theme-2 .date,
    #sermons-live.green-screen-theme-2 .title {
        color: #ffffff;
        /* text-shadow: 10px 10px 15px #090c0d; */
    }

    /*GREEN SCREEN 3 THEME*/
    #sermons-live.green-screen-theme-3 {
        background-color: transparent !important;
        padding-bottom: 8px;
    }

    #sermons-live.green-screen-theme-3 .slides-lyrics {
        z-index: 3;
        line-height: 1.25;
        padding: 30px 50px 10px 50px; 
        background: #222222;
        box-shadow: 5px 5px 10px;
        position: relative;
        min-width:1125px; 
        border-radius: 5px;
        border: 2px solid #5b7c8a;
        max-width: 1350px;
    }

    .valign-wrapper.green-screen-theme-3 {
        justify-content: flex-end;
        flex-direction: column;
    }

    #sermons-live.green-screen-theme-3 .verse {
        border-left-color: transparent;
        border: none;
        padding-left: 0;
    }

    #sermons-live.green-screen-theme-3 .reference {
        background: #5b7c8a;
        color: #ffffff !important;
        /* width: 500px;
        text-align: center;
        display: block; */
        text-shadow: none;
        top: -35px;
        position: absolute;
        border-radius: 5px;
        text-shadow: none;   
    }

    #sermons-live.green-screen-theme-3 .reference,
    #sermons-live.green-screen-theme-3 .verse,
    #sermons-live.green-screen-theme-3 .custom,
    #sermons-live.green-screen-theme-3 .lyrics,
    #sermons-live.green-screen-theme-3 .songTitle,
    #sermons-live.green-screen-theme-3 .message,
    #sermons-live.green-screen-theme-3 .date,
    #sermons-live.green-screen-theme-3 .title {
        color: #ffffff;
        /* text-shadow: 10px 10px 15px #090c0d; */
    }

    /*WHITE SCREEN THEME*/
    #sermons-live.white-screen-theme {
        background-color: #f9f9f9;
    }

    #sermons-live.white-screen-theme .verse {
        border-left-color: transparent;
        border: none;
        padding-left: 0;
    }

    #sermons-live.white-screen-theme .reference {
        background: #090c0d;
        color: #ffffff !important;
        /* width: 500px;
        text-align: center;
        display: block; */
    }

    #sermons-live.white-screen-theme .reference,
    #sermons-live.white-screen-theme .verse,
    #sermons-live.white-screen-theme .custom,
    #sermons-live.white-screen-theme .lyrics,
    #sermons-live.white-screen-theme .songTitle,
    #sermons-live.white-screen-theme .message,
    #sermons-live.white-screen-theme .date,
    #sermons-live.white-screen-theme .title {
        color: #090c0d;
        /* text-shadow: 10px 10px 15px #090c0d; */
    }

    @media (max-width: 992px) {
        html {
            font-size: 10px
        }

        #sermons-live .reference {
            font-size: 1.5rem !important;
            width: 100%;
            display: block;
            text-align: center;
        }   
    }

    @media (max-width: 767px) {
        #sermons-live {
            height: 100%;
            display: block;
        }
    }

    #sermons-live.green-screen-theme-2 .booya-left,
    #sermons-live.green-screen-theme-3 .booya-left {
        /* animation-name: example-left; */
        animation-duration: 20s;
        width: 350px; 
        height: 15px; 
        background: #5b7c8a;
        top: -10px;
        left: 35px;
        position: absolute; 
        border-radius: 5px;
        animation-iteration-count: infinite;
    }

    #sermons-live.green-screen-theme-2 .booya-right,
    #sermons-live.green-screen-theme-3 .booya-right {
        /* animation-name: example-right; */
        animation-duration: 20s;
        width: 350px; 
        height: 15px; 
        background: #5b7c8a;
        bottom: -10px;
        right: 35px;
        position: absolute; 
        border-radius: 5px;
        animation-iteration-count: infinite;
    }
    
    @keyframes example-left {
        /* 0%   {left:-10px; top:-22px;} */
        /* 25%  {left:0px; top:-22px;}
        50%  {left:100px; top:-22px;}
        75%  {left:200px; top:-22px;} */
        50% {left:100px; width: 250px}
        100% {left:-10px; width: 350px}
    }

    @keyframes example-right {
        /* 0%   {left:-10px; top:-22px;} */
        /* 25%  {left:0px; top:-22px;}
        50%  {left:100px; top:-22px;}
        75%  {left:200px; top:-22px;} */
        50% {right:50px; }
        100% {right:-10px;}
    }

    #article {
        max-width: 1024px;
    }

    #article .article-source {
        font-size: 1.5rem;
        display: flex;
        align-items: center;
        column-gap: 12px;
        margin-bottom: 14px;
        font-weight: bold;
        font-family: monospace;
        text-transform: uppercase;
        color: black;
    }

    #article .article-source .article-source-line {
        flex-grow: 1;
        height: 2px;
        background-color: #5b7c8a;
    }

    #article .articleContent { 
        background-color: white;
        border: 4px solid black;
        padding: 16px;
        height: 100%;
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
        border-radius: 5px;
    }

    #article .articleContent .article-title { 
        font-size: 5rem;
        line-height: 5rem;
        font-family: 'Times New Roman', Times, serif;
    }

    #article .articleContent .article-details { 
        display: flex;
        margin-top: 1rem;
        font-size: 1.5rem;
        line-height: 1.75rem;
    }

    #article .articleContent .article-details .article-author { 
        flex-grow: 1;
        text-align: left;
    }

    #article .articleContent .article-details .article-date { 
        flex-grow: 1;
        text-align: right;
    }

    #article .articleContent .article-image-div {
        margin-top: 1.5rem;
        text-align: center;
    }

    #article .articleContent .article-image-div img {
        height: 50vh;
        border-radius: 3px;
    }

    #sermons-live.green-screen-theme-3 #article .article-source {
        color: #ffffff;
    }

    #sermons-live.green-screen-theme-3 #article .articleContent .article-title { 
        font-size: 36px;
        line-height: 40px;
    }

    #sermons-live.green-screen-theme-3 #article .articleContent .article-details { 
        font-size: 1rem;
        line-height: 1.25rem;
    }

    #sermons-live.green-screen-theme-3 #article .article-source {
        font-size: 1rem;
    }

    #sermons-live.green-screen-theme-2 #article .article-source,
    #sermons-live.hofcc-ani-theme #article .article-source {
        color: #ffffff !important;
    }

</style>
